module.exports = __webpack_public_path__ + "img/timeline_bg_animated.b190012d.svg";